<template>
  <div class="riseup-header">
    <div>
      <slot name="right-side" />
    </div>
    <div>
      <slot name="left-side" />
    </div>
  </div>
</template>

<script>
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/mixins';
@import '@riseupil/base-ui/src/scss/riseup-vars';

.riseup-header {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  width: 100%;
  height: $app_header_height;
  border-bottom: 1px solid $riseup_gray_0;
  background-color: $riseup_white;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  z-index: 200;

  div {
    display: flex;
    align-items: center;
  }
}

</style>
